import { css } from '@emotion/css';

export const roleplayCardStyles = css`
  width: 61.6rem !important;
`;

export const roleplayCardMobileStyles = css`
  width: 100%;
`;
